export const replaceInfoBubbleCloseIcon = () => {
    const closeElement = document.getElementsByClassName("H_ib_close H_btn")[0];
    if(closeElement) {
        closeElement.innerHTML = bubbleCloseIcon;
    }
}
const bubbleCloseIcon = '<svg aria-hidden="true" class="H_icon" viewBox="0 0 12 12"><path d="m8.12 6 3.66-3.66c.29-.29.29-.76 0-1.05L10.72.23a.742.742 0 0 0-1.05 0L6.01 3.89 2.35.23a.742.742 0 0 0-1.05 0L.24 1.29c-.29.29-.3.76 0 1.05L3.9 6 .24 9.66c-.29.29-.29.76 0 1.05l1.06 1.06c.29.29.76.29 1.05 0l3.66-3.66 3.66 3.66c.29.29.76.29 1.05 0l1.06-1.06c.29-.29.3-.76 0-1.05z" fill="#fff"/></svg>';